/* common UI constants, such as character-code mappings, can be found here */

export const LEFT_ARROW = 37;
export const RIGHT_ARROW = 39;

export const MOBILE_MAX = 767;
export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_MAX}px)`;
